import { render, staticRenderFns } from "./ModalRenameWorkflow.vue?vue&type=template&id=2ffd0e43&scoped=true&"
import script from "./ModalRenameWorkflow.vue?vue&type=script&lang=js&"
export * from "./ModalRenameWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./ModalRenameWorkflow.vue?vue&type=style&index=0&id=2ffd0e43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffd0e43",
  null
  
)

export default component.exports